<ng-container *transloco="let t">
  <app-page-template>
    <div class="container">
      <div class="pt-120-0 pb-300-100">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <h1>
            {{ t('app.user.my.tracy') }}
          </h1>
          <div class="avatar-wrapper pt-3">
            <div class="el-1">
              <div>
                <div class="avatar-button">
                  <img [src]="currentUserDetails?.picture ?? 'assets/img/blank_profile.webp'" class="avatar"
                       alt="Avatar">
                </div>
              </div>
            </div>
          </div>
          <div class="pb-5">
            <p class="large pt-1 text-uppercase">
              {{ currentUserDetails?.firstname }} {{ currentUserDetails?.lastname }}
            </p>
          </div>
          <section class="w-100">
            <app-nav-tabs [active]="activeTab">
              <app-nav-tab [title]="t('app.landing.upcoming.events')" [itemId]="1">
                <ng-template>
                  <div class="pt-16 pb-16">
                    <app-loader [isLoading]="isLoadingUpcomingRegisteredEvents"></app-loader>
                    <section>
                      @if (upcomingRegisteredEvents.length ?? 0 > 0) {
                        <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
                          @for (item of upcomingRegisteredEvents; track trackByFn) {
                            <div class="col mb-4">
                              <app-event-grid-item-with-image-alt [eventItem]="item" [countries]="countries"
                                                                  [isLanding]="true"
                                                                  (onRightButtonClickCallback)="goToEventDetailsPage(item, false)"
                                                                  [languages]="languages"
                                                                  [isFinishedEvent]="false"/>
                            </div>
                          }
                        </div>
                      } @else if (!isLoadingUpcomingRegisteredEvents) {
                        <app-empty-state [contentKeys]="['app.common.my.upcoming.no.events']"/>
                      }
                      @if ((upcomingRegisteredEvents.length ?? 0 > 0) && hasMoreEvents) {
                        <div class="d-flex justify-content-center load-more-wrapper">
                          <app-button-alt [text]="t('app.common.load.more.events')" [borderColor]="'var(--teal-500)'"
                                          [textColor]="'var(--grey-neutral-800)'"
                                          (onClickCallback)="loadMore()" [buttonColor]="'transparent'"/>
                        </div>
                      }
                    </section>
                  </div>
                </ng-template>
              </app-nav-tab>
              <app-nav-tab [title]="t('app.common.favorite.events')" [itemId]="2">
                <ng-template>
                  <div class="pt-16 pb-16">
                    <app-loader [isLoading]="isLoadingFavoriteItems"></app-loader>
                    <section>
                      @if (favoriteItems.length ?? 0 > 0) {
                        <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
                          @for (item of favoriteItems; track trackByFn) {
                            <div class="col mb-4">
                              <app-event-grid-item-with-image-alt [eventItem]="item" [countries]="countries"
                                                                  [isLanding]="true"
                                                                  (onRightButtonClickCallback)="goToEventDetailsPage(item, false, true)"
                                                                  [languages]="languages"
                                                                  [isFinishedEvent]="false"/>
                            </div>
                          }
                        </div>
                      } @else if (!isLoadingFavoriteItems) {
                        <app-empty-state [contentKeys]="['app.common.favorite.no.events']"/>
                      }
                      @if ((favoriteItems.length ?? 0 > 0) && hasMoreEvents) {
                        <div class="d-flex justify-content-center load-more-wrapper">
                          <app-button-alt [text]="t('app.common.load.more.events')" [borderColor]="'var(--teal-500)'"
                                          [textColor]="'var(--grey-neutral-800)'"
                                          (onClickCallback)="loadMore()" [buttonColor]="'transparent'"/>
                        </div>
                      }
                    </section>
                  </div>
                </ng-template>
              </app-nav-tab>
              <app-nav-tab [title]="t('page.header.my.finished.events')" [itemId]="3">
                <ng-template>
                  <div class="pt-16 pb-16">
                    <app-loader [isLoading]="isLoadingPastRegisteredEvents"></app-loader>
                    <section>
                      @if (pastRegisteredEvents.length ?? 0 > 0) {
                        <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
                          @for (item of pastRegisteredEvents; track trackByFn) {
                            <div class="col mb-4">
                              <app-event-grid-item-with-image-alt [eventItem]="item" [countries]="countries"
                                                                  [isLanding]="true"
                                                                  (onRightButtonClickCallback)="goToEventDetailsPage(item, true)"
                                                                  [languages]="languages"
                                                                  [isFinishedEvent]="true"/>
                            </div>
                          }
                        </div>
                      } @else if (!isLoadingPastRegisteredEvents) {
                        <app-empty-state [contentKeys]="['app.common.my.finished.no.events']"/>
                      }
                      @if ((pastRegisteredEvents.length ?? 0 > 0) && hasMoreEvents) {
                        <div class="d-flex justify-content-center load-more-wrapper">
                          <app-button-alt [text]="t('app.common.load.more.events')" [borderColor]="'var(--teal-500)'"
                                          [textColor]="'var(--grey-neutral-800)'"
                                          (onClickCallback)="loadMore()" [buttonColor]="'transparent'"/>
                        </div>
                      }
                    </section>
                  </div>
                </ng-template>
              </app-nav-tab>
            </app-nav-tabs>
          </section>
        </div>
      </div>
    </div>
  </app-page-template>
</ng-container>
